export enum ProgressType {
  Line = 'line',
  Circle = 'circle',
  Dashboard = 'dashboard'
}
